<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import PeopleCard from '@@home/components/PeopleCard.vue';

import shenfen from '@@home/assets/law/shenfen.jpg';
import songlei from '@@home/assets/law/songlei.jpg';
import weijiangong from '@@home/assets/law/weijiangong.jpg';
import xumeiling from '@@home/assets/law/xumeiling.jpg';
import zhouminghui from '@@home/assets/law/zhouminghui.jpg';

const { t } = useI18n();

const openPeople = [
  {
    photo: zhouminghui,
    title: t('law.pepele1.title'),
    name: t('law.pepele1.name'),
  },
  {
    photo: weijiangong,
    title: t('law.pepele2.title'),
    name: t('law.pepele2.name'),
  },
  {
    photo: shenfen,
    title: t('law.pepele3.title'),
    name: t('law.pepele3.name'),
  },
  {
    photo: songlei,
    title: t('law.pepele4.title'),
    name: t('law.pepele4.name'),
  },
  {
    photo: xumeiling,
    title: t('law.pepele5.title'),
    name: t('law.pepele5.name'),
  },
]
</script>

<template>
  <div class="markdown-expert-review-group my-32px">
    <ul class="m-0 flex flex-wrap p-0 <2xl:flex-nowrap">
      <li v-for="item in openPeople" :key="item.name" class="h-160px w-223px list-none not-last-of-type:mr-44px <2xl:not-last-of-type:mr-8px">
        <PeopleCard :name="item.name" :photo="item.photo" :position="item.title" />
      </li>
    </ul>
  </div>
</template>
